/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_TradePreClearanceRequestListDto } from '../models/PagedResultDto_TradePreClearanceRequestListDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_TradePreClearance_PreClearanceRequestStatusDto } from '../models/Wealthlane_AwardService_Dtos_TradePreClearance_PreClearanceRequestStatusDto';
import type { Wealthlane_AwardService_Dtos_TradePreClearance_RejectPreClearanceRequestDto } from '../models/Wealthlane_AwardService_Dtos_TradePreClearance_RejectPreClearanceRequestDto';
import type { Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto } from '../models/Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TradePreClearanceApprovalService {

    /**
     * @param tradePreClearanceReqId 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTradePreClearanceApprovalApprovePreClearanceRequest(
tradePreClearanceReqId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/trade-pre-clearance-approval/approve-pre-clearance-request/{tradePreClearanceReqId}',
            path: {
                'tradePreClearanceReqId': tradePreClearanceReqId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTradePreClearanceApprovalRejectPreClearanceRequest(
requestBody?: Wealthlane_AwardService_Dtos_TradePreClearance_RejectPreClearanceRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/trade-pre-clearance-approval/reject-pre-clearance-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds 
     * @param awardTypeId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_TradePreClearanceRequestListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTradePreClearanceApprovalPreClearanceRequestList(
approvalStatusIds?: Array<number>,
awardTypeId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_TradePreClearanceRequestListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/trade-pre-clearance-approval/pre-clearance-request-list',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'AwardTypeId': awardTypeId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTradePreClearanceApprovalPreClearanceRequest(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/trade-pre-clearance-approval/{id}/pre-clearance-request',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_TradePreClearance_PreClearanceRequestStatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTradePreClearanceApprovalApprovalStatus(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TradePreClearance_PreClearanceRequestStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/trade-pre-clearance-approval/approval-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
